(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDrag(grid) {
      var isDragging = false;
      var startX = 0;
      var scrollStart = 0;
      var moved = false;

      grid.addEventListener('mousedown', function (e) {
        isDragging = true;
        moved = false;
        startX = e.pageX;
        scrollStart = grid.scrollLeft;
        grid.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        grid.classList.remove('is-dragging');
        if (moved) {
          grid.style.scrollSnapType = '';
        }
      });

      grid.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var delta = e.pageX - startX;
        if (Math.abs(delta) > 4) moved = true;
        if (!moved) return;
        e.preventDefault();
        grid.scrollLeft = scrollStart - delta;
      });

      grid.addEventListener('click', function (e) {
        if (moved) e.stopPropagation();
      }, true);
    }

    document.querySelectorAll('.product-comparison__grid').forEach(initDrag);
  })();

  } catch(e) { console.error(e); }
})();
})();
